<template>
  <div :class="{ 'dark-mode': darkMode }">
    <Notifications />
    <LayoutMain>
      <router-view />
    </LayoutMain>
  </div>
</template>

<script>
import LayoutMain from './components/LayoutMain.vue'
import { mapState } from 'vuex'

export default {
  name: 'App',
  components: { LayoutMain },
  computed: {
    ...mapState('darkMode', ['darkMode'])
  }
}
</script>
